import Url from '@music/mobile-url';
import { makeActionCreator, makeActionType, getActionType } from '../util/redux';
import Request from '../util/fetch';
import { Toast } from '../component/message';

export const PAGESIZE = 15;
export const WorkType = 'mv';
const mockUserId = Url.CurrentParams.mockUserId || '';

makeActionType(WorkType, ['request0', 'request1', 'delrequest', 'delcomplete', 'savepage', 'tryrequest', 'trycomplete', 'clearsgtab', 'edititem', 'querylistrequest', 'queryliststatus', 'craftsuccess', 'craftfail']);
export const mvClear = makeActionCreator(getActionType(WorkType, 'clear'));
export const mvSuccess = makeActionCreator(getActionType(WorkType, 'success'));
export const mvFail = makeActionCreator(getActionType(WorkType, 'fail'));
export const mvComplete = makeActionCreator(getActionType(WorkType, 'delcomplete'));
export const mvSavePage = makeActionCreator(getActionType(WorkType, 'savepage'));
export const mvTryComplete = makeActionCreator(getActionType(WorkType, 'trycomplete'));
export const mvClearTab = makeActionCreator(getActionType(WorkType, 'clearsgtab'));
export const mvEidtItem = makeActionCreator(getActionType(WorkType, 'edititem'));
export const mvQueryList = makeActionCreator(getActionType(WorkType, 'queryliststatus'));
export const craftSuccess = makeActionCreator(getActionType(WorkType, 'craftsuccess'));
export const craftFail = makeActionCreator(getActionType(WorkType, 'craftfail'));
/**
 * 发布状态：发布中（0），已发布（1）、已锁定（-1）
 */
export const PublishType = {
    publishing: 0,
    published: 1,
    publishFailed: -1,
};

export const TabType = {
    published: 0,
    publishFailed: 1,
};

export const TabToPublishTypeMap = {
    [TabType.published]: PublishType.published,
    [TabType.publishFailed]: PublishType.publishFailed
};

export const mvRequest = data => (dispatch) => {
    const type = TabToPublishTypeMap[data.status];
    const {
        status, // 0, 1
        page,
    } = data;
    dispatch({
        type: getActionType(WorkType, `request${status}`),
        payload: data
    });
    console.log(typeof status);

    return Request.fetch({
        url: '/api/cloudvideo/mv/list',
        data: {
            status: type,
            limit: PAGESIZE,
            offset: (page - 1) * PAGESIZE,
        }
    }).then((result) => {
        const resData = result.data;
        resData._status = status;
        resData._page = page;
        dispatch(mvSuccess(resData));
    })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            rerr._status = status;
            dispatch(mvFail(rerr));
        });
};

// 删除
export const mvDelRequest = data => (dispatch) => {
    const {
        status, // 0, 1
        page,
        videoId,
        resourceType = 'MV',
    } = data;
    dispatch({
        type: getActionType(WorkType, 'delrequest'),
        payload: {
            videoId
        }
    });
    return Request.fetch({
        url: 'api/cloudvideo/video/delete',
        data: {
            videoId,
            mockUserId,
            resourceType
        }
    })
        .then(() => {
            Toast({
                type: 'success',
                text: '删除成功'
            });
            if (page) {
                dispatch(mvComplete({
                    success: true,
                    page,
                    status,
                    videoId
                }));
            }
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            Toast({
                type: 'error',
                text: rerr.msg
            });
            dispatch(mvComplete(rerr));
        });
};



// WEBPACK FOOTER //
// ./client/action/mv.js